import React from 'react';
import { TranslateFocusedStatePageHeader } from '../../TranslateFocusedStatePageHeader';
import type { FreddieIconProps } from '../../interfaces';

export function FreddieIcon({ className }: FreddieIconProps) {
  const translations = TranslateFocusedStatePageHeader();
  return (
    <img
      className={className}
      src="https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/logos/logo-freddie.svg"
      alt={translations.freddieIconAltText}
    />
  );
}
